module.exports = __webpack_public_path__ + "img/rule-bg.877e558c.png";